import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, withDirectives as _withDirectives, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, vModelText as _vModelText, resolveComponent as _resolveComponent, createBlock as _createBlock, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "invoice-container" }
const _hoisted_2 = { class: "invoice-actions" }
const _hoisted_3 = ["disabled"]
const _hoisted_4 = ["disabled"]
const _hoisted_5 = { class: "reassign-wrapper" }
const _hoisted_6 = ["disabled"]
const _hoisted_7 = ["value"]
const _hoisted_8 = {
  key: 0,
  class: "reassign-popover",
  role: "dialog",
  "aria-modal": "true",
  "aria-describedby": 'reassign-popover-desc'
}
const _hoisted_9 = {
  id: "reassign-popover-desc",
  class: "reassign-popover-description"
}
const _hoisted_10 = { class: "dropdown" }
const _hoisted_11 = {
  key: 0,
  class: "comments-count"
}
const _hoisted_12 = {
  key: 0,
  class: "dropdown-menu"
}
const _hoisted_13 = { class: "history-controls" }
const _hoisted_14 = { class: "invoice-comment-section" }
const _hoisted_15 = { class: "meta" }
const _hoisted_16 = { key: 0 }
const _hoisted_17 = {
  key: 1,
  class: "no-rows"
}
const _hoisted_18 = { class: "invoice-layout" }
const _hoisted_19 = { class: "invoice-content" }
const _hoisted_20 = { class: "invoice-details" }
const _hoisted_21 = { class: "invoice-section" }
const _hoisted_22 = { open: "" }
const _hoisted_23 = { class: "content-header" }
const _hoisted_24 = { class: "content-header-badge" }
const _hoisted_25 = { class: "invoice-details-list" }
const _hoisted_26 = { class: "detail-label" }
const _hoisted_27 = { class: "detail-value" }
const _hoisted_28 = { class: "invoice-description" }
const _hoisted_29 = { class: "detail-value" }
const _hoisted_30 = { class: "invoice-section" }
const _hoisted_31 = { class: "content-header" }
const _hoisted_32 = { class: "content-header-badge" }
const _hoisted_33 = { class: "invoice-details-list" }
const _hoisted_34 = { class: "invoice-detail-item" }
const _hoisted_35 = { class: "detail-value" }
const _hoisted_36 = { class: "invoice-detail-item" }
const _hoisted_37 = { class: "detail-value" }
const _hoisted_38 = { class: "invoice-detail-item" }
const _hoisted_39 = { class: "detail-value" }
const _hoisted_40 = { class: "invoice-details-list" }
const _hoisted_41 = { class: "detail-label" }
const _hoisted_42 = { class: "detail-value" }
const _hoisted_43 = { class: "invoice-section" }
const _hoisted_44 = { class: "content-header" }
const _hoisted_45 = { class: "content-header-badge" }
const _hoisted_46 = { class: "accounting-actions" }
const _hoisted_47 = { class: "action-dropdown" }
const _hoisted_48 = {
  key: 0,
  id: "action-menu",
  class: "action-dropdown-menu"
}
const _hoisted_49 = { class: "accounting-table-container" }
const _hoisted_50 = {
  key: 0,
  class: "accounting-table"
}
const _hoisted_51 = ["title"]
const _hoisted_52 = {
  key: 1,
  class: "no-rows"
}
const _hoisted_53 = { class: "accounting-summary" }
const _hoisted_54 = { class: "total" }
const _hoisted_55 = {
  key: 0,
  class: "warning-text"
}
const _hoisted_56 = {
  key: 0,
  class: "invoice-image-container"
}
const _hoisted_57 = { class: "invoice-image-header" }
const _hoisted_58 = { class: "header-actions" }
const _hoisted_59 = ["value"]
const _hoisted_60 = ["href", "download"]
const _hoisted_61 = ["src", "alt"]
const _hoisted_62 = ["src"]
const _hoisted_63 = {
  key: 2,
  class: "unsupported-file"
}
const _hoisted_64 = { class: "file-info" }
const _hoisted_65 = {
  key: 0,
  class: "file-comment"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InvoiceHistoryLine = _resolveComponent("InvoiceHistoryLine")!
  const _component_InvoiceAccountingRow = _resolveComponent("InvoiceAccountingRow")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("button", {
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.approve && _ctx.approve(...args))),
        class: "btn btn-approve",
        disabled: _ctx.hasBalanceWarning || _ctx.saving,
        title: "Approve the invoice."
      }, " Approve Invoice ", 8, _hoisted_3),
      _createElementVNode("button", {
        onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.approveAndNext && _ctx.approveAndNext(...args))),
        class: "btn btn-approve",
        disabled: _ctx.hasBalanceWarning || _ctx.saving,
        title: "Approve the invoice and move to next."
      }, " Approve & Next ", 8, _hoisted_4),
      _createElementVNode("div", _hoisted_5, [
        _cache[21] || (_cache[21] = _createElementVNode("label", {
          for: "reassign-user",
          class: "sr-only"
        }, "Select user to re-assign", -1)),
        _withDirectives(_createElementVNode("select", {
          id: "reassign-user",
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.selectedUserId) = $event)),
          class: "btn reassign-select",
          disabled: _ctx.saving,
          title: "Re-assign the invoice to another user.",
          onChange: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.handleUserSelect && _ctx.handleUserSelect(...args)))
        }, [
          _cache[18] || (_cache[18] = _createElementVNode("option", { value: "" }, "Re-assign", -1)),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.users, (u) => {
            return (_openBlock(), _createElementBlock("option", {
              key: u.id,
              value: u.id
            }, _toDisplayString(u.name), 9, _hoisted_7))
          }), 128))
        ], 40, _hoisted_6), [
          [_vModelSelect, _ctx.selectedUserId]
        ]),
        (_ctx.showPopover)
          ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
              _createElementVNode("span", _hoisted_9, [
                _cache[19] || (_cache[19] = _createTextVNode("Assign to ", -1)),
                _createElementVNode("b", null, _toDisplayString(_ctx.selectedUserName), 1),
                _cache[20] || (_cache[20] = _createTextVNode("?", -1))
              ]),
              _createElementVNode("button", {
                class: "btn btn-approve reassign-actions",
                onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.confirmReassign && _ctx.confirmReassign(...args))),
                autofocus: ""
              }, "Confirm"),
              _createElementVNode("button", {
                class: "btn btn-reject reassign-actions",
                onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.cancelReassign && _ctx.cancelReassign(...args)))
              }, "Cancel")
            ]))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_10, [
        _createElementVNode("button", {
          onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.toggleDropdown && _ctx.toggleDropdown(...args))),
          class: "btn dropdown-toggle"
        }, [
          _cache[22] || (_cache[22] = _createTextVNode("Comments ", -1)),
          (_ctx.commentsCount > 0)
            ? (_openBlock(), _createElementBlock("span", _hoisted_11, _toDisplayString(_ctx.commentsCount), 1))
            : _createCommentVNode("", true),
          _cache[23] || (_cache[23] = _createTextVNode(" & History ▼", -1))
        ]),
        (_ctx.dropdownOpen)
          ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
              _createElementVNode("div", _hoisted_13, [
                _createElementVNode("div", _hoisted_14, [
                  _cache[24] || (_cache[24] = _createElementVNode("span", { class: "detail-label" }, " Invoice Comment ", -1)),
                  _withDirectives(_createElementVNode("textarea", {
                    class: "comment-input",
                    "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.localInvoice.comment) = $event)),
                    onInput: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.handleCommentChange && _ctx.handleCommentChange(...args))),
                    rows: "2",
                    placeholder: "Add a comment...",
                    maxlength: "3000"
                  }, null, 544), [
                    [_vModelText, _ctx.localInvoice.comment]
                  ]),
                  _createElementVNode("span", _hoisted_15, "Characters: " + _toDisplayString(_ctx.localInvoice.comment ? _ctx.localInvoice.comment.length : 0) + "/3000", 1)
                ]),
                _cache[26] || (_cache[26] = _createElementVNode("label", {
                  for: "history-filter",
                  class: "sr-only"
                }, "Show", -1)),
                _withDirectives(_createElementVNode("select", {
                  id: "history-filter",
                  "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.historyFilter) = $event)),
                  class: "attachment-selector"
                }, [...(_cache[25] || (_cache[25] = [
                  _createElementVNode("option", { value: "comments" }, "Comments only", -1),
                  _createElementVNode("option", { value: "all" }, "All history", -1)
                ]))], 512), [
                  [_vModelSelect, _ctx.historyFilter]
                ])
              ]),
              (_ctx.filteredHistory?.length)
                ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filteredHistory, (line) => {
                      return (_openBlock(), _createBlock(_component_InvoiceHistoryLine, {
                        key: line.timestamp + line.username,
                        line: line
                      }, null, 8, ["line"]))
                    }), 128))
                  ]))
                : (_openBlock(), _createElementBlock("p", _hoisted_17, "No history available."))
            ]))
          : _createCommentVNode("", true)
      ])
    ]),
    _createElementVNode("div", _hoisted_18, [
      _createElementVNode("div", _hoisted_19, [
        _createElementVNode("div", _hoisted_20, [
          _createElementVNode("div", _hoisted_21, [
            _createElementVNode("details", _hoisted_22, [
              _createElementVNode("summary", null, [
                _createElementVNode("div", _hoisted_23, [
                  _cache[27] || (_cache[27] = _createElementVNode("div", { class: "content-header-title" }, [
                    _createElementVNode("h3", null, "Invoice Details")
                  ], -1)),
                  _createElementVNode("div", _hoisted_24, " Approval status: " + _toDisplayString(_ctx.localInvoice.approvalStatusTitle), 1)
                ])
              ]),
              _createElementVNode("dl", _hoisted_25, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.primaryDetails, (label, index) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: index,
                    class: "invoice-detail-item"
                  }, [
                    _createElementVNode("dt", _hoisted_26, _toDisplayString(label.name), 1),
                    _createElementVNode("dd", _hoisted_27, _toDisplayString(label.value || '-'), 1)
                  ]))
                }), 128))
              ])
            ]),
            _createElementVNode("div", _hoisted_28, [
              _cache[28] || (_cache[28] = _createElementVNode("span", { class: "detail-label" }, "Note", -1)),
              _createElementVNode("p", _hoisted_29, _toDisplayString(_ctx.localInvoice.invoiceDescription || '-'), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_30, [
            _createElementVNode("details", null, [
              _createElementVNode("summary", null, [
                _createElementVNode("div", _hoisted_31, [
                  _cache[29] || (_cache[29] = _createElementVNode("div", { class: "content-header-title" }, [
                    _createElementVNode("h3", null, "More Details")
                  ], -1)),
                  _createElementVNode("div", _hoisted_32, " Invoice status: " + _toDisplayString(_ctx.localInvoice.invoiceStatus), 1)
                ]),
                _createElementVNode("dl", _hoisted_33, [
                  _createElementVNode("div", _hoisted_34, [
                    _cache[30] || (_cache[30] = _createElementVNode("dt", { class: "detail-label" }, "Our reference ", -1)),
                    _createElementVNode("dd", _hoisted_35, _toDisplayString(_ctx.localInvoice.ourReference || '-'), 1)
                  ]),
                  _createElementVNode("div", _hoisted_36, [
                    _cache[31] || (_cache[31] = _createElementVNode("dt", { class: "detail-label" }, "Vendor Bank Account ", -1)),
                    _createElementVNode("dd", _hoisted_37, _toDisplayString(_ctx.localInvoice.vendorBankAccountNumber), 1)
                  ]),
                  _createElementVNode("div", _hoisted_38, [
                    _cache[32] || (_cache[32] = _createElementVNode("dt", { class: "detail-label" }, "Invoice Id ", -1)),
                    _createElementVNode("dd", _hoisted_39, _toDisplayString(_ctx.localInvoice.externalId), 1)
                  ])
                ]),
                _cache[33] || (_cache[33] = _createElementVNode("br", null, null, -1))
              ]),
              _createElementVNode("dl", _hoisted_40, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.invoiceDetails, (label, index) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: index,
                    class: "invoice-detail-item"
                  }, [
                    _createElementVNode("dt", _hoisted_41, _toDisplayString(label.name), 1),
                    _createElementVNode("dd", _hoisted_42, _toDisplayString(label.value || '-'), 1)
                  ]))
                }), 128))
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_43, [
            _createElementVNode("div", _hoisted_44, [
              _cache[34] || (_cache[34] = _createElementVNode("div", { class: "content-header-title" }, [
                _createElementVNode("h3", null, "Accounting Rows")
              ], -1)),
              _createElementVNode("div", _hoisted_45, " Accounted: " + _toDisplayString(_ctx.localInvoice.accounted ? 'Yes' : 'No'), 1)
            ]),
            _createElementVNode("div", _hoisted_46, [
              _createElementVNode("div", _hoisted_47, [
                _createElementVNode("button", {
                  class: "btn btn-dropdown",
                  onClick: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_ctx.toggleCopyDropdown && _ctx.toggleCopyDropdown(...args))),
                  type: "button"
                }, " Copy from first row ▼ "),
                (_ctx.copyDropdownOpen)
                  ? (_openBlock(), _createElementBlock("ul", _hoisted_48, [
                      _createElementVNode("li", null, [
                        _createElementVNode("button", {
                          onClick: _cache[11] || (_cache[11] = 
//@ts-ignore
(...args) => (_ctx.copyVatCodes && _ctx.copyVatCodes(...args))),
                          class: "dropdown-item"
                        }, "VAT codes")
                      ]),
                      _createElementVNode("li", null, [
                        _createElementVNode("button", {
                          onClick: _cache[12] || (_cache[12] = 
//@ts-ignore
(...args) => (_ctx.copyVatPercentages && _ctx.copyVatPercentages(...args))),
                          class: "dropdown-item"
                        }, "VAT percentages")
                      ]),
                      _createElementVNode("li", null, [
                        _createElementVNode("button", {
                          onClick: _cache[13] || (_cache[13] = 
//@ts-ignore
(...args) => (_ctx.copyAccountNumbers && _ctx.copyAccountNumbers(...args))),
                          class: "dropdown-item"
                        }, "Account numbers")
                      ]),
                      _createElementVNode("li", null, [
                        _createElementVNode("button", {
                          onClick: _cache[14] || (_cache[14] = 
//@ts-ignore
(...args) => (_ctx.copyDimensions && _ctx.copyDimensions(...args))),
                          class: "dropdown-item"
                        }, "Dimensions")
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("button", {
                onClick: _cache[15] || (_cache[15] = 
//@ts-ignore
(...args) => (_ctx.addRow && _ctx.addRow(...args))),
                class: "btn btn-add"
              }, "Add Accounting Row")
            ]),
            _createElementVNode("div", _hoisted_49, [
              (_ctx.localInvoice.accountingRows?.length > 0)
                ? (_openBlock(), _createElementBlock("table", _hoisted_50, [
                    _createElementVNode("colgroup", null, [
                      _cache[35] || (_cache[35] = _createElementVNode("col", { style: {"width":"200px"} }, null, -1)),
                      _cache[36] || (_cache[36] = _createElementVNode("col", { style: {"width":"80px"} }, null, -1)),
                      _cache[37] || (_cache[37] = _createElementVNode("col", { style: {"width":"100px"} }, null, -1)),
                      _cache[38] || (_cache[38] = _createElementVNode("col", { style: {"width":"80px"} }, null, -1)),
                      _cache[39] || (_cache[39] = _createElementVNode("col", { style: {"width":"120px"} }, null, -1)),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.dimensions, (dimension) => {
                        return (_openBlock(), _createElementBlock("col", {
                          key: dimension.id,
                          style: {"width":"120px"}
                        }))
                      }), 128))
                    ]),
                    _createElementVNode("thead", null, [
                      _createElementVNode("tr", null, [
                        _cache[40] || (_cache[40] = _createElementVNode("th", null, "Product name", -1)),
                        _cache[41] || (_cache[41] = _createElementVNode("th", null, "Amount", -1)),
                        _cache[42] || (_cache[42] = _createElementVNode("th", null, "Vat code", -1)),
                        _cache[43] || (_cache[43] = _createElementVNode("th", null, "Vat %", -1)),
                        _cache[44] || (_cache[44] = _createElementVNode("th", null, "Account", -1)),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.dimensions, (dimension) => {
                          return (_openBlock(), _createElementBlock("th", {
                            key: dimension.id,
                            title: dimension.name
                          }, _toDisplayString(dimension.name), 9, _hoisted_51))
                        }), 128))
                      ])
                    ]),
                    _createElementVNode("tbody", null, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.localInvoice.accountingRows, (row) => {
                        return (_openBlock(), _createBlock(_component_InvoiceAccountingRow, {
                          key: row.id,
                          row: row,
                          accounts: _ctx.accounts,
                          dimensions: _ctx.dimensions,
                          vatCodes: _ctx.vatCodes,
                          onUpdateRow: _ctx.handleRowUpdate,
                          onRemoveRow: _ctx.handleRowRemove
                        }, null, 8, ["row", "accounts", "dimensions", "vatCodes", "onUpdateRow", "onRemoveRow"]))
                      }), 128))
                    ])
                  ]))
                : (_openBlock(), _createElementBlock("p", _hoisted_52, "No accounting rows added yet."))
            ]),
            _createElementVNode("div", _hoisted_53, [
              _createElementVNode("div", _hoisted_54, [
                _cache[45] || (_cache[45] = _createElementVNode("strong", null, "Total Accounting Amount:", -1)),
                _createTextVNode(" " + _toDisplayString(_ctx.formatCurrency(_ctx.totalAccountingAmount)), 1)
              ]),
              _createElementVNode("div", {
                class: _normalizeClass(["balance", { 'balance-warning': _ctx.hasBalanceWarning }])
              }, [
                _cache[46] || (_cache[46] = _createElementVNode("strong", null, "Balance:", -1)),
                _createTextVNode(" " + _toDisplayString(_ctx.formatCurrency(_ctx.balance)) + " ", 1),
                (_ctx.hasBalanceWarning)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_55, " Accounting total doesn't match invoice amount "))
                  : _createCommentVNode("", true)
              ], 2)
            ])
          ])
        ])
      ]),
      (_ctx.selectedAttachment)
        ? (_openBlock(), _createElementBlock("div", _hoisted_56, [
            _createElementVNode("div", _hoisted_57, [
              _createElementVNode("div", _hoisted_58, [
                _withDirectives(_createElementVNode("select", {
                  "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.selectedAttachmentIndex) = $event)),
                  class: "attachment-selector"
                }, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.localInvoice.attachments, (attachment, index) => {
                    return (_openBlock(), _createElementBlock("option", {
                      key: attachment.fileName,
                      value: index
                    }, _toDisplayString(attachment.fileName), 9, _hoisted_59))
                  }), 128))
                ], 512), [
                  [_vModelSelect, _ctx.selectedAttachmentIndex]
                ]),
                _createElementVNode("i", null, _toDisplayString(_ctx.selectedAttachment.comment), 1),
                _createElementVNode("a", {
                  href: _ctx.getDownloadUrl(_ctx.selectedAttachment),
                  download: _ctx.selectedAttachment.fileName,
                  class: "download-link"
                }, " Download ⬇️ ", 8, _hoisted_60)
              ])
            ]),
            (_ctx.isImage(_ctx.selectedAttachment.contentType))
              ? (_openBlock(), _createElementBlock("div", {
                  key: 0,
                  class: _normalizeClass(["invoice-image-wrapper", { 'expanded': _ctx.isImageExpanded }])
                }, [
                  _createElementVNode("img", {
                    src: _ctx.getDataUrl(_ctx.selectedAttachment),
                    alt: _ctx.selectedAttachment.fileName,
                    class: "invoice-image",
                    onClick: _cache[17] || (_cache[17] = 
//@ts-ignore
(...args) => (_ctx.toggleImageSize && _ctx.toggleImageSize(...args)))
                  }, null, 8, _hoisted_61)
                ], 2))
              : (_ctx.isPdf(_ctx.selectedAttachment.contentType))
                ? (_openBlock(), _createElementBlock("div", {
                    key: 1,
                    class: _normalizeClass(["pdf-viewer-wrapper", { 'expanded': _ctx.isImageExpanded }])
                  }, [
                    _createElementVNode("iframe", {
                      src: _ctx.getPdfUrl(_ctx.selectedAttachment),
                      class: "pdf-viewer"
                    }, null, 8, _hoisted_62)
                  ], 2))
                : (_openBlock(), _createElementBlock("div", _hoisted_63, [
                    _cache[47] || (_cache[47] = _createElementVNode("div", { class: "file-icon" }, "📄", -1)),
                    _createElementVNode("p", null, _toDisplayString(_ctx.selectedAttachment.fileName), 1),
                    _createElementVNode("p", _hoisted_64, _toDisplayString(_ctx.selectedAttachment.contentType), 1),
                    (_ctx.selectedAttachment.comment)
                      ? (_openBlock(), _createElementBlock("p", _hoisted_65, _toDisplayString(_ctx.selectedAttachment.comment), 1))
                      : _createCommentVNode("", true)
                  ]))
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}